import React from "react";

import BaseMobilityRanking from "./BaseMobilityRanking";

export default function ({ level, ...props }) {
  return <BaseMobilityRanking type="bottom" level={level} {...props} />;
}
